import React from 'react'
import Cases from '../../components/cases/Cases'

const index = () => {
  return (
    <div>
        <Cases />
    </div>
  )
}

export default index